import {makeResource} from 'app/infrastructure/repository'
import { Referent } from './_models';

const REFERENT_ENDPOINT = 'referents';

export default makeResource<Referent>(REFERENT_ENDPOINT);

